import type { StringTable } from '../types'

export const es: StringTable = {
  'common.playbackSpeed': 'Velocidad de reproducción',
  // Navigation
  'nav.review': 'Repasar',
  'nav.library': 'Biblioteca',
  'nav.stats': 'Estadísticas',
  'nav.settings': 'Ajustes',
  'nav.appTitleSuffix': 'Tarjetas de vocabulario',
  'nav.openMenu': 'Abrir menú',
  'nav.closeMenu': 'Cerrar menú',
  'nav.mainNav': 'Navegación principal',
  'nav.reviewSession': 'Sesión de repaso',
  'nav.cardLibrary': 'Biblioteca de tarjetas',
  'nav.media': 'Videos',
  'nav.statistics': 'Estadísticas',
  'nav.create.label': 'Crear',
  'nav.create.text': 'Texto',
  'nav.create.doc': 'Documento',
  'nav.create.media': 'Vídeo / Audio',

  // Generate view
  'generate.takePhoto': 'Cámara',
  'generate.changePhoto': 'Cambiar foto',
  'generate.chooseGallery': 'Galería',
  'generate.clearText': 'Borrar texto',
  'generate.button': 'Generar tarjetas',
  'generate.buttonPhoto': 'Generar desde foto',
  'generate.buttonText': 'Generar desde texto',
  'generate.buttonBoth': 'Generar desde foto + texto',
  'generate.buttonLoading': 'Generando...',
  'generate.minInput': 'Agrega una foto o texto para empezar',
  'generate.convertingHeic': 'Convirtiendo HEIC...',
  'generate.compressing': 'Comprimiendo...',
  'generate.retry': 'Reintentar',
  'generate.removeImage': 'Quitar imagen',
  'generate.cardTextInput': 'Entrada de texto de la tarjeta',
  'generate.preview': 'Vista previa',

  // Generate errors
  'generate.error.invalidImage': 'Sube una imagen (JPEG, PNG, GIF, WebP o HEIC)',
  'generate.error.imageTooLarge': 'La imagen debe pesar menos de {{maxSize}}',
  'generate.error.compressionFailed': 'La imagen sigue siendo muy pesada después de comprimir. Intenta con una foto más pequeña.',
  'generate.error.heicFailed': 'No se pudo procesar la imagen',
  'generate.error.generateFailed': 'No se pudieron generar las tarjetas',

  // Generate — daily cap / upgrade
  'generate.cap.body': 'Tu saldo está vacío ({{balance}} energía). Recarga para seguir generando.',
  'generate.cap.upgrade': 'Recargar',

  // Generate — energy badge + first-session banner (balance visibility)
  'generate.energyBadge.label': 'Saldo de energía: {{balance}}',
  'generate.energyBadge.zero': 'Sin energía',
  'generate.firstCard.body': 'Tienes {{balance}} de energía, suficiente para tus primeras tarjetas. Escribe una palabra abajo para probarlo →',
  'generate.firstCard.dismiss': 'Cerrar',
  'generate.sampleWords.label': 'Prueba con:',
  'generate.aiImageToggle': 'Imagen IA',
  'generate.aiImageHint': 'Añade una imagen IA a las tarjetas que guardes ({{cost}}/tarjeta)',
  'generate.aiImageAutoSkip': 'No se pudieron añadir algunas imágenes IA — toca el botón de imagen en cada tarjeta para reintentar.',

  // Library view
  'library.loading': 'Cargando biblioteca...',
  'library.retry': 'Reintentar',
  'library.noCards': '¡Aún no tienes tarjetas!',
  'library.noCardsHint': 'Genera algunas tarjetas para crear tu biblioteca.',
  'library.emptyExtensionHint': 'Consejo: selecciona cualquier palabra mientras ves YouTube y guárdala con la extensión Piccard.',
  'library.emptyCta': 'Crea tu primera tarjeta',
  'library.dismiss': 'Cerrar',
  'library.deleteTitle': '¿Eliminar tarjeta?',
  'library.deleteConfirm': 'Esta acción no se puede deshacer. ¿Estás seguro?',
  'library.cancel': 'Cancelar',
  'library.deleting': 'Eliminando...',
  'library.delete': 'Eliminar',
  'library.filterAll': 'Todas',
  'library.filterLearning': 'Aprendiendo',
  'library.filterMastered': 'Dominadas',
  'library.card_one': '{{count}} tarjeta',
  'library.card_other': '{{count}} tarjetas',
  'library.match_one': '{{count}} coincidencia',
  'library.match_other': '{{count}} coincidencias',
  'library.noCardsMatch': 'Ninguna tarjeta coincide con "{{query}}"',
  'library.prevPage': 'Página anterior',
  'library.nextPage': 'Página siguiente',
  'library.searchImagesFor': 'Buscar imágenes de {{word}}',
  'library.unmaster': 'Desmarcar {{word}} como dominada',
  'library.markMastered': 'Marcar {{word}} como dominada',
  'library.searchPlaceholder': 'Buscar {{filter}}tarjetas...',
  'library.drag': 'ARRASTRAR',
  'library.swipeHint': '← Eliminar · Ver →',
  'library.back': 'Reverso',
  'library.images': 'Imágenes',
  'library.master': 'Dominar',
  'library.mastered': 'Dominada',
  'library.view': 'Ver',
  'library.fromMedia': 'De multimedia',
  'library.fromDoc': 'De documento',

  // Review view
  'review.ready': '¿Listo para repasar?',
  'review.readyHint': 'Elige un tema o empieza con todas las tarjetas pendientes',
  'review.recognition': 'Reconocimiento',
  'review.production': 'Producción',
  'review.topics': 'Temas',
  'review.domains': 'Dominios',
  'review.startReview': 'Empezar repaso',
  'review.loading': 'Cargando tarjetas...',
  'review.retry': 'Reintentar',
  'review.tapFlip': 'Toca para voltear',
  'review.answer': 'Respuesta',
  'review.newWord': 'Palabra nueva',
  'review.cardProgress': 'Tarjeta {{current}} de {{total}}',
  'review.searchImagesFor': 'Buscar imágenes de {{word}}',
  'review.allCaughtUp': '¡Todo al día!',
  'review.nothingToReview': 'No hay nada que repasar ahora.',
  'review.makeSomeCards': 'Crear tarjetas',
  'review.makeMoreCards': 'Crear más tarjetas de "{{topic}}"',
  'review.backToReview': 'Volver al repaso',
  'review.noMatchTitle': 'Ninguna tarjeta coincide con "{{topic}}"',
  'review.noMatchHint': 'Incluyendo tarjetas que coinciden parcialmente con tu tema',
  'review.fallbackTitle': 'Ninguna tarjeta coincide con "{{topic}}" — aquí están todas las pendientes',
  'review.sessionComplete': '¡Sesión completada!',
  'review.cardsReviewed': 'Tarjetas repasadas',
  'review.again': 'Otra vez',
  'review.hard': 'Difícil',
  'review.good': 'Bien',
  'review.easy': 'Fácil',
  'review.timeSpent': 'Tiempo empleado',
  'review.cardReviewed_one': '{{count}} tarjeta repasada hoy',
  'review.cardReviewed_other': '{{count}} tarjetas repasadas hoy',
  'review.startNewSession': 'Iniciar nueva sesión',

  // Share check-in card (issue #1 — /s/:slug poster pages)
  'share.cta': 'Comparte tu tarjeta de hoy',
  'share.title': 'Comparte tu progreso',
  'share.name': 'Nombre visible',
  'share.create': 'Crear enlace para compartir',
  'share.copied': '¡Enlace copiado!',
  'share.open': 'Abrir página compartida',
  'share.saveImage': 'Guardar imagen',
  'share.myLinks': 'Mis enlaces compartidos',
  'share.revoke': 'Revocar',
  'share.empty': 'Aún no hay enlaces: termina una sesión de repaso para compartir tu racha.',
  'review.tapOrSpace': 'Toca la tarjeta o presiona Espacio para voltearla',
  'review.images': 'Imágenes',
  'review.prefillMore': 'más palabras y expresiones sobre {{topic}}',
  'review.endSession': 'Terminar sesión',
  'review.error.loadFailed': 'No se pudieron cargar las tarjetas',
  'review.error.submitFailed': 'No se pudo enviar el repaso',

  // Stats view
  'stats.today': 'Hoy',
  'stats.reviewedToday': 'repasadas hoy',
  'stats.review_one': 'repaso',
  'stats.review_other': 'repasos',
  'stats.mastered': 'dominadas',
  'stats.learned': 'palabras aprendidas',
  'stats.word_one': 'palabra',
  'stats.word_other': 'palabras',
  'stats.error': 'No se pudieron cargar las estadísticas',
  'stats.dailyGoal': 'Meta diaria',
  'stats.goalFresh': 'Un nuevo comienzo.',
  'stats.goalGoing': 'Sigue así.',
  'stats.goalMet': 'Meta cumplida, buen trabajo.',
  'stats.goalHint': 'Toca para marcar tu ritmo',

  // Settings view
  'settings.title': 'Ajustes',
  'settings.languagePair': 'Par de idiomas',
  'settings.learn': 'Aprender',
  'settings.pairOption': '{{native}} → Aprender {{target}}',
  'settings.pairGroup': '{{langA}} ↔ {{langB}}',
  'settings.cardsPerSession': 'Tarjetas por sesión',
  'settings.cardLabel': '{{count}} tarjetas',
  'settings.changeWarning': 'Cambiar el idioma recargará la aplicación',
  'settings.apply': 'Aplicar',
  'settings.cancelChange': 'Cancelar',

  // Settings — learning context (free-text goal that tunes AI generation)
  'settings.learningContext.label': 'Objetivo de aprendizaje',
  'settings.learningContext.optional': 'opcional',
  'settings.learningContext.placeholder': 'p. ej. vocabulario GRE, HSK, inglés de negocios…',
  'settings.learningContext.hint': 'Influye en las palabras que elige la IA. Vacío para valores por defecto.',
  'settings.learningContext.try': 'Probar:',
  'settings.learningContext.example1': 'Preparación HSK',
  'settings.learningContext.example2': 'Inglés de negocios',
  'settings.learningContext.example3': 'Conversación diaria',
  'settings.learningContext.example4': 'Inglés australiano',

  // Settings — subscription
  'settings.plan.balanceTitle': 'Saldo de energía',
  'settings.plan.balanceDesc': '{{balance}} energía disponible',
  'settings.plan.topup': 'Recargar ${{amount}}',
  'settings.plan.energyUnit': '{{energy}} energía',
  'settings.plan.bonusPct': '+{{percent}}% bonus',
  'settings.plan.bestValue': 'Mejor valor',
  'settings.support.title': '¿Necesitas ayuda?',
  'settings.support.desc': 'Preguntas, facturación o sugerencias — escríbenos.',
  'settings.referral.title': 'Invita amigos, los dos reciben 150 energía',
  'settings.referral.desc': 'Comparte tu enlace. Cuando un amigo recarga, cada uno recibe 150 energía gratis.',
  'settings.referral.yourCode': 'Tu código de invitación',
  'settings.referral.copyCode': 'Copiar código de invitación',
  'settings.referral.tapToCopy': 'Toca para copiar',
  'settings.referral.codeCopied': 'Copiado',
  'settings.referral.shareLink': 'Compartir enlace',
  'settings.referral.invited_one': '{{count}} amigo invitado',
  'settings.referral.invited_other': '{{count}} amigos invitados',
  'settings.referral.toppedUp_one': '{{count}} recargó',
  'settings.referral.toppedUp_other': '{{count}} recargaron',
  'settings.referral.pendingHint': 'Esperando su primera recarga — ¡recuérdaselo!',
  'settings.referral.shareText': 'Aprende vocabulario con fotos de tu vida. Al recargar, ambos recibimos 150 energía — prueba Piccard:',
  'settings.referral.rewardBanner': 'Tu amigo recargó — añadimos 150 energía a tu saldo.',
  'settings.referral.rewardDismiss': 'Entendido',
  'settings.referral.haveCode': '¿Tienes un código de invitación?',
  'settings.referral.codePlaceholder': 'Introduce el código',
  'settings.referral.codeApply': 'Aplicar',
  'settings.referral.codeApplying': 'Aplicando…',
  'settings.referral.codeApplied': 'Código aplicado — cuando recargues, tú y tu invitador reciben 150 energía cada uno.',
  'settings.referral.codeAlready': 'Ya tienes una invitación aplicada a tu cuenta.',
  'settings.referral.codeInvalid': 'Ese código no es válido.',
  'settings.referral.codeSelf': 'Ese es tu propio código.',

  // Payment (shared)
  'payment.checkoutFailed': 'No se pudo iniciar el pago. Inténtalo de nuevo.',
  'payment.checkoutLoading': 'Abriendo el pago…',
  'payment.checkoutSuccess': 'Recarga recibida — ¡gracias!',
  'payment.checkoutCancelled': 'Pago cancelado.',

  // Hamburger menu
  'menu.notSignedIn': 'No has iniciado sesión',
  'menu.signOut': 'Cerrar sesión',
  'menu.languageLearner': 'Estudiante de idiomas',

  // Onboarding
  'onboarding.iSpeak': 'Hablo...',
  'onboarding.imLearning': 'Quiero aprender...',
  'onboarding.startLearning': 'Empezar a aprender',
  'onboarding.changeAnytime': 'Puedes cambiar esto en cualquier momento.',
  'onboarding.back': '← Atrás',
  'onboarding.learningContext.label': '¿Estudias para algo específico?',
  'onboarding.learningContext.placeholder': 'p. ej. GRE, HSK, inglés de negocios… (opcional)',

  // Auth
  'auth.signInPrompt': 'Inicia sesión para guardar tu vocabulario en la nube',
  'auth.continueWithGoogle': 'Continuar con Google',
  'auth.continueWithKakao': 'Continuar con Kakao',
  'auth.signingIn': 'Iniciando sesión...',
  'auth.signingYouIn': 'Iniciando tu sesión...',
  'auth.signInFailed': 'No se pudo iniciar sesión',
  'auth.signInError': 'Hubo un problema durante la autenticación.',
  'auth.tryAgain': 'Intentar de nuevo',
  'auth.loading': 'Cargando...',

  // Error boundary
  'error.title': 'Algo salió mal',
  'error.description': 'Ocurrió un error inesperado.',
  'error.tryAgain': 'Intentar de nuevo',
  'error.report': 'Reportar',

  // Offline
  'offline.title': 'Estás sin conexión',
  'offline.description': 'Algunas funciones pueden estar limitadas. Revisa tu conexión.',
  'offline.notification': 'Notificación sin conexión',
  'offline.retryConnection': 'Reintentar conexión',

  // PWA install
  'pwa.installPrompt': 'Instala Piccard para usarla sin conexión',
  'pwa.install': 'Instalar',
  'pwa.dismiss': 'Cerrar',
  'pwa.installAppPrompt': 'Solicitud para instalar la app',
  'pwa.installApp': 'Instalar app',

  // Card stack
  'cardStack.cardGenerated': '1 tarjeta generada',
  'cardStack.cardGenerated_other': '{{count}} tarjetas generadas',
  'cardStack.counter': '{{current}} / {{total}} tarjetas',
  'cardStack.done': 'Listo',
  'cardStack.reviewNow': 'Repasar ahora',
  'cardStack.generateMore': 'Generar más',
  'cardStack.allReviewed': 'Todas las tarjetas revisadas',
  'cardStack.cardsSaved': '{{count}} tarjetas guardadas',
  'cardStack.previousCard': 'Tarjeta anterior',
  'cardStack.nextCard': 'Tarjeta siguiente',
  'cardStack.goToCard': 'Ir a la tarjeta {{n}}',

  // Preview card
  'previewCard.generatedCard': 'Tarjeta generada',
  'previewCard.translation': 'Traducción',
  'previewCard.definition': 'Definición',
  'previewCard.example': 'Ejemplo',
  'previewCard.searchImagesFor': 'Buscar imágenes de {{word}}',

  // Rating buttons
  'rating.again': 'Otra vez',
  'rating.hard': 'Difícil',
  'rating.good': 'Bien',
  'rating.easy': 'Fácil',
  'rating.master': 'Dominar',
  'rating.rateAs': 'Calificar como {{label}}',
  'rating.markMastered': 'Marcar como dominada',
  'review.stuckHint': "Esta tarjeta se te ha escapado {{count}}× — no es culpa tuya, algunas tarjetas simplemente no se fijan. Retírala abajo o sigue.",

  // Study card
  'studyCard.studyCardFor': 'Tarjeta de estudio: {{word}}',
  'studyCard.playUsPronunciation': 'Escuchar pronunciación estadounidense',
  'studyCard.playUkPronunciation': 'Escuchar pronunciación británica',
  'studyCard.searchImagesFor': 'Buscar imágenes de {{word}}',

  // Pronunciation button + badge
  'pronunciation.play': 'Escuchar pronunciación {{accent}}',

  // Search bar
  'search.clearSearch': 'Borrar búsqueda',

  // Tag cloud
  'tagCloud.yourTopics': 'Tus temas',
  'tagCloud.showMore': 'Mostrar {{count}} {{label}} más',

  // Queue item
  'queueItem.remove': 'Quitar {{word}}',

  // Error card
  'errorCard.defaultRetry': 'Intentar de nuevo',

  // Empty state
  'emptyState.noCards': 'Aún no tienes tarjetas',
  'emptyState.noCardsHint': 'Crea tu primera tarjeta para empezar',
  'emptyState.createCard': 'Crear tarjeta',
  'emptyState.noMastered': 'Aún no tienes palabras dominadas.',
  'emptyState.noMasteredHint': 'Marca tarjetas como dominadas para verlas aquí.',
  'emptyState.allMastered': '¡Todas tus tarjetas están dominadas!',
  'emptyState.greatJob': '¡Excelente trabajo!',

  // Progress bar
  'progressBar.cardsLearned': 'Tarjetas aprendidas',

  // AI image regeneration (shared RegenerateImageButton)
  'common.aiImage': 'Imagen IA',
  'common.aiImagePremium': 'Premium',
  'common.aiImageAria': 'Generar imagen IA para {{word}}',
  'common.generating': 'Generando…',
  'common.imageFailed': 'Falló · sin gastar energía',
  'common.lowEnergy': 'Energía baja',
  'common.regenerateCard': 'Regenerar',
  'common.regenerateCardAria': 'Regenerar completamente {{word}}',

  // Image preview / lightbox
  'imagePreview.enlarge': 'Ampliar imagen',
  'imagePreview.close': 'Cerrar',

  // Document import view (PDF/TXT → candidate vocab)
  'importView.title': 'Importar un documento',
  'importView.subtitle': 'Convierte un PDF o texto en tarjetas de vocabulario.',
  'importView.chooseFile': 'Elegir archivo PDF o de texto',
  'importView.pasteLabel': 'O pega texto',
  'importView.pastePlaceholder': 'Pega tu artículo, notas o cualquier texto…',
  'importView.findVocab': 'Buscar vocabulario',
  'importView.proposing': 'Buscando vocabulario…',
  'importView.parsing': 'Leyendo documento…',
  'importView.candidates': '{{count}} candidatos',
  'importView.keepN': 'Conservar {{count}} · {{energy}} energía',
  'importView.generate': 'Generar {{count}} tarjetas',
  'importView.selectAll': 'Seleccionar todo',
  'importView.clearAll': 'Borrar selección',
  'importView.priorityHigh': 'Alto valor',
  'importView.highCount': '{{high}} de alto valor de {{total}}',
  'mediaView.selectRecommended': 'Seleccionar recomendadas',
  'importView.success': '{{count}} tarjetas añadidas a tu biblioteca',
  'importView.pairMismatch': 'Las tarjetas se guardarán como {{pair}} — tu app está en {{current}}. Cambia en Ajustes para repasarlas.',
  'importView.savedAs': 'Guardado como {{pair}}',
  'importView.reviewInPair': 'Cambiar a {{pair}} y repasar',
  'importView.reviewNow': 'Repasar ahora',
  'importView.errorTooLarge': 'El documento es demasiado grande (máx. ~800K caracteres).',
  'importView.errorScanned': 'No hay texto seleccionable — parece un PDF escaneado.',
  'importView.errorRead': 'No se pudo leer este archivo.',
  'importView.errorPropose': 'No se pudo extraer vocabulario. Inténtalo de nuevo.',
  'importView.errorRateLimited': 'Demasiadas peticiones seguidas. Espera un minuto e inténtalo de nuevo.',
  'importView.errorLowEnergy': 'No tienes suficiente energía para guardar estas tarjetas.',
  'importView.empty': 'No se encontró vocabulario. Prueba otro documento.',
  'importView.proposingWait': 'Eligiendo palabras y escribiendo definiciones: 10–20 s en textos largos.',
  'importView.phaseReading': 'Leyendo tu texto…',
  'importView.foundSoFar': '{{n}} encontradas · buscando más…',
  'importView.cancel': 'Cancelar',
  'importView.partialBanner': 'Se encontraron {{n}} palabras, pero el análisis se detuvo antes de tiempo.',
  'importView.retryRest': 'Buscar el resto',

  // Quick save view (extension lookup → one-step card)
  'quickSave.title': 'Guardar en Piccard',
  'quickSave.subtitle': 'Un toque y tu tarjeta está lista para repasar.',
  'quickSave.generate': 'Generar tarjeta',
  'quickSave.generateCost': 'Generar tarjeta · {{energy}} de energía',
  'quickSave.generating': 'Creando tu tarjeta…',
  'quickSave.slowWait': 'Crear tu tarjeta suele tardar unos segundos.',
  'quickSave.pairSourceExtension': 'de este vídeo',
  'quickSave.pairSourceSettings': 'ajustes de la app',
  'quickSave.pairSourceBrowser': 'idioma del navegador',
  'quickSave.fromYoutube': 'De este vídeo',
  'quickSave.fromNetflix': 'De esta serie',
  'quickSave.pairLabel': 'Idioma de la tarjeta',
  'quickSave.energyHint': 'Generar cuesta {{energy}} de energía · saldo {{balance}}',
  'quickSave.errorBalance': 'No hay energía suficiente para generar esta tarjeta.',
  'quickSave.errorNetwork': 'No se pudo generar la tarjeta. Inténtalo de nuevo.',
  'quickSave.topUp': 'Recargar',
  'card.fromSource': 'De tu documento',
  'card.grammar': 'Gramática',
  'card.prosody': 'Acento y ritmo',
  'card.fromClip': 'Clip',
  'card.fromYoutube': 'YouTube',
  'card.openInNetflix': 'Abrir en Netflix',
  'card.fromNetflix': 'Netflix',
  'card.fromPdf': 'PDF',
  'card.fromPhoto': 'Tu foto',
  'card.lookedUp': 'Palabra buscada',
  'card.expand': 'Expandir',
  'card.collapse': 'Contraer',

  'mediaView.title': 'Convierte un clip en tarjetas',
  'mediaView.subtitle': 'Sube audio o video en inglés. Nosotros transcribimos, tú eliges.',
  'mediaView.chooseFile': 'Suelta el archivo o toca para elegir',
  'mediaView.formats': 'mp4 · mov · webm · mp3…',
  'mediaView.cap': 'Hasta 90 min · hasta 100 MB',
  'mediaView.guideExtension.body': '¿Instalaste la extensión? Selecciona cualquier palabra de los subtítulos en un video de YouTube/Netflix y toca el botón de Piccard para guardar una tarjeta. También puedes importar tu propio archivo de video/audio abajo →',
  'mediaView.guideExtension.dismiss': 'Cerrar',
  'mediaView.uploading': 'Subiendo…',
  'mediaView.transcribe': 'Transcribir',
  'mediaView.transcribing': 'Transcribiendo…',
  'mediaView.transcribeHint': 'Un clip corto tarda unos segundos.',
  'mediaView.changeFile': 'Cambiar archivo',
  'mediaView.costN': '{{energy}} energía',
  'mediaView.phrases': '{{count}} frases',
  'mediaView.make': 'Crear {{count}} tarjetas',
  'mediaView.uncertain': 'Revisa esta frase',
  'mediaView.preview': 'Reproducir esta frase',
  'mediaView.success': '{{count}} tarjetas listas para repasar',
  'mediaView.errorUpload': 'Subida fallida. Inténtalo de nuevo.',
  'mediaView.errorTooLarge': 'Más de 100 MB — recórtalo más corto.',
  'mediaView.errorSilent': 'No se detectó voz audible. Puede ser un vídeo silencioso — elige un clip con diálogo.',
  'mediaView.errorFormat': 'Formato no admitido. Usa mp4, mov, webm o un archivo de audio.',
  'mediaView.errorTranscribe': 'Servicio ocupado. Reintenta — sin cargo.',
  'mediaView.tooLongDuration': 'Más de {{n}} minutos — recorta el clip más corto y vuelve a añadirlo.',
  'mediaView.errorContent': 'No se detectó habla en inglés en este archivo.',
  'mediaView.errLanguageMismatch': 'Este clip no suena a {{lang}}. Elige material en {{lang}} o cambia antes tu idioma de aprendizaje.',
  'mediaView.errBadFormat': 'El formato real de este archivo no se puede transcribir (p. ej., un .avi/.mkv renombrado a .mp4). Conviértelo a mp4, mov, webm o un formato de audio estándar.',
  'mediaView.errNoSpeech': 'No se detectó voz en este archivo. Elige un fragmento con diálogo claro.',
  'mediaView.errDecode': 'No se pudo procesar el audio de este archivo. Prueba con un mp4, mov, webm o archivo de audio estándar.',
  'mediaView.fromFile': 'de {{name}}',
  'mediaView.errorLowEnergy': 'Energía insuficiente.',
  'mediaView.errorConfirm': 'No se pudieron crear tarjetas de estas frases. Inténtalo de nuevo.',
  'mediaView.empty': 'No se encontraron frases en este clip.',
  'mediaView.costEstimate': '~{{cost}} energía · ~{{min}} min',
  'mediaView.feeApplied': '(se cobró {{n}} energía de detección)',
  'settings.section.energy': 'Energía',
  'settings.section.learning': 'Aprendizaje',
  'redeem.title': 'Canjear código',
  'redeem.desc': 'Introduce un código para recibir energía.',
  'redeem.placeholder': 'Introduce el código',
  'redeem.apply': 'Canjear',
  'redeem.applying': '…',
  'redeem.success': '¡Canjeado! +{{cents}} energía',
  'redeem.already': 'Ya canjeaste este código.',
  'redeem.invalid': 'Código inválido o expirado',
  'redeem.error': 'Algo salió mal. Inténtalo de nuevo.',
  'redeem.balance': '{{balance}} energía disponible',

  // Landing page (v11 — extension-first entry, closed loop. Copy frozen in
  // docs/plans/landing-v11.md; locale from ?lang / ?ref hint / navigator.languages)
  'landing.hero.title': 'Aprende inglés\ncon YouTube.',
  'landing.hero.subtitle': 'Subtítulos bilingües en los videos en inglés que ves. Toca una línea y crea las tarjetas con un clic — significado, frase de ejemplo, pronunciación — y cada una regresa justo antes de que la olvides.',
  'landing.hero.cta': 'Empezar',
  'landing.hero.ctaNote': 'Gratis. Sin tarjeta de crédito.',
  'landing.hero.ctaExtension': 'Añadir a Chrome',
  'landing.hero.videoCaption': 'Del panel bilingüe a Piccard — una línea se convierte en varias tarjetas candidatas.',
  'landing.how.title': 'De YouTube a tarjetas de vocabulario',
  'landing.how.subtitle': 'El ciclo se cierra solo: lo que ves se convierte en lo que repasas.',
  'landing.how.step1Title': 'Mira con subtítulos bilingües',
  'landing.how.step1Desc': 'La extensión de Chrome superpone subtítulos en tu idioma sobre el video que estás viendo — cada línea, sincronizada al segundo.',
  'landing.how.step2Title': 'Toca una línea. Quédate con las tarjetas.',
  'landing.how.step2Desc': 'Un toque envía la línea a Piccard. Un clic crea las tarjetas — significado, frase de ejemplo y pronunciación en cada una. Quédate con lo que valga la pena y descarta el resto.',
  'landing.how.step3Title': 'El repaso vuelve a ti',
  'landing.how.step3Desc': 'La repetición espaciada FSRS programa cada tarjeta para que vuelva justo antes de que la olvides — y cada una reproduce el momento exacto de YouTube del que salió.',
  'landing.how.otherTitle': 'Otras formas de entrar',
  'landing.how.other3': 'Doble clic en una palabra mientras navegas — aparece una definición sin conexión, y Piccard crea la tarjeta con un clic más.',
  'landing.how.ownLink': '¿Ya tienes una lista de palabras? Tráela →',

  // landing-v12 P1-2: persona-2 section (OwnMaterial.tsx) — bring your own list
  'landing.bring.title': 'Trae tu propia lista',
  'landing.bring.subtitle': 'Los videos son una forma de empezar. La mayoría de las palabras que necesitas ya están en alguna parte — un capítulo del libro de texto, la lista de un examen, una grabación de clase. Pega o sube el material: Piccard propone las tarjetas y tú te quedas con las que vale la pena aprender.',
  'landing.bring.pasteTitle': 'Pega el texto',
  'landing.bring.pasteDesc': 'Una página del libro, un artículo, la lista que ya tienes. Pégala y las tarjetas propuestas vuelven — selecciónalas todas o quédate con las que valen la pena. Hasta 20 tarjetas por confirmación.',
  'landing.bring.pdfTitle': 'Suelta un PDF',
  'landing.bring.pdfDesc': 'Material de curso, listas de examen, lecturas — un PDF pasa por la misma propuesta. Las tarjetas se despliegan, tú marcas, una confirmación.',
  'landing.bring.fileTitle': 'Sube audio o video',
  'landing.bring.fileDesc': 'Una clase o podcast en inglés (hasta 90 minutos) se transcribe — cada frase recibe una puntuación de 0 a 100 sobre si vale la pena aprenderla (tu objetivo cuenta) y las recomendadas llegan ya marcadas. El audio debe estar en el idioma que aprendes (inglés, si aprendes inglés).',
  'landing.bring.cta': 'Abrir la app',
  'landing.bring.ctaNote': 'Gratis para empezar. Sin tarjeta de crédito.',
  'landing.pricing.title': 'Paga solo por lo que usas',
  'landing.pricing.subtitle': 'Empieza con energía gratuita. Recarga cuando quieras — nunca caduca.',
  'landing.pricing.starter': 'Inicial',
  'landing.pricing.starterPrice': '$0',
  'landing.pricing.starterToBegin': 'para empezar',
  'landing.pricing.starterGrant': '150 de energía gratis al registrarte',
  'landing.pricing.starterSwitch': 'Cambia de idioma cuando quieras',
  'landing.pricing.starterSrs': 'Repetición espaciada completa',
  'landing.pricing.starterDevices': 'Funciona en cualquier dispositivo',
  'landing.pricing.starterSync': 'Sincronización en la nube incluida',
  'landing.pricing.starterCta': 'Empezar',
  'landing.pricing.topup': 'Paquetes de recarga',
  'landing.pricing.topupRate': '1 energía ≈ 1 tarjeta de texto',
  'landing.pricing.starterAiImage': 'Tarjetas de texto incluidas; las tarjetas de imagen con IA son de pago',
  'landing.pricing.topupCards': '500 tarjetas por $5',
  'landing.blog.backHome': '← Inicio',
  'landing.welcome.openApp': 'Abrir Piccard',
  'landing.faq.heading': 'Preguntas frecuentes',
  'landing.faq.q1': '¿De verdad es gratis Piccard?',
  'landing.faq.a1': '¡Sí! Cada cuenta nueva recibe 150 de energía gratis, suficiente para unos videos, PDFs o unas 150 tarjetas. Recarga con paquetes de energía ($5/$10/$20) solo cuando quieras más. La energía nunca caduca.',
  'landing.faq.q2': '¿En qué se diferencia de Language Reactor o Anki?',
  'landing.faq.a2': 'Ambas son buenas herramientas con un hueco entre ellas: Language Reactor muestra subtítulos, pero guardar palabras implica exportar e importar a Anki, y Anki en sí requiere configuración de verdad — construyes cada tarjeta a mano. Piccard cierra ese hueco. Toca una línea de subtítulos y las tarjetas ya están hechas — significado, frase de ejemplo, pronunciación — quédate con lo que valga la pena, descarta el resto, y la repetición espaciada FSRS-6, el algoritmo más nuevo que Anki también ofrece, se encarga de la programación. Y al importar videos más largos, cada frase recibe una puntuación de 0 a 100 de cuánto vale la pena aprenderla —razón de una línea al pasar el cursor, tu objetivo de aprendizaje en la mezcla—, así que nunca tienes que adivinar qué palabras merecen tu tiempo. Sin configuración, y sin exportar ni importar.',
  'landing.faq.q3': '¿Ralentiza YouTube o estropea los subtítulos?',
  'landing.faq.a3': 'No. La extensión es ligera — añade su propio panel de subtítulos sobre el video y nunca modifica YouTube en sí. Si algún día no la quieres, un clic lo elimina todo. También funciona sin cuenta.',
  'landing.faq.q5': '¿Qué es la repetición espaciada?',
  'landing.faq.a5': 'Un algoritmo de planificación decide cuándo debe volver cada tarjeta — pronto mientras está fresca, más tarde cuando se asienta en la memoria a largo plazo. Piccard usa FSRS-6, la generación más nueva de la ciencia detrás de Anki, y tus tarjetas salen de lo que ves y lees.',
  'landing.faq.q7': '¿Qué idiomas admite Piccard?',
  'landing.faq.a7': '한국어 · 繁體中文 · 日本語 primero — Piccard está hecho para hablantes de coreano, chino tradicional y japonés que aprenden inglés. Español, francés y alemán también disponibles. Cambia cuando quieras.',

  'landing.faq.q8': 'Ya tengo mi propia lista de palabras. ¿Puede Piccard convertirla en tarjetas?',
  'landing.faq.a8': 'Sí — es la forma más rápida de empezar. Pega el texto o suelta el PDF y Piccard propone las tarjetas (hasta 20 por vez): significado, frase de ejemplo y pronunciación. Las grabaciones de clase también valen — sube el audio, se transcribe y cada frase recibe una puntuación de 0 a 100.',
  'landing.faq.q9': '¿Funciona con Netflix?',
  'landing.faq.a9': 'Sí, en títulos con subtítulos de texto — si el título ofrece ambos idiomas, Piccard muestra subtítulos bilingües (inglés + tu idioma) sobre el vídeo. Mira con el panel de Piccard abierto, toca una línea y se convierte en una tarjeta que vuelve al segundo exacto en Netflix. Algunos títulos usan subtítulos en imagen que no se pueden leer, y el DRM impide capturas o audio — lo que conservas son las palabras y el momento.',
  'landing.faq.still': '¿Aún tienes preguntas? Escribe a',
  'landing.footer.tagline': 'Tarjetas de vocabulario de lo que ves',
  'landing.footer.blog': 'Blog',
  'landing.footer.privacy': 'Privacidad',
  'landing.footer.terms': 'Términos',
  'landing.footer.contact': 'Contacto',
  'landing.footer.rights': 'Todos los derechos reservados.',
  'landing.finalCta.title': 'Tu primera tarjeta de vocabulario está a un video de YouTube de distancia',
  'landing.finalCta.subtitle': 'Mira algo. Toca una línea. Crea la tarjeta — vuelve antes de que la olvides.',
  'landing.finalCta.cta': 'Empezar gratis',
  'landing.finalCta.ctaExtension': 'Añadir a Chrome',
  'landing.finalCta.note': 'Sin tarjeta de crédito. 150 de energía incluida.',

  // SEO — prerendered HTML shells (docs/plans/multilingual-seo.md M1)
  'seo.title': 'Aprender inglés con YouTube — Subtítulos bilingües | Piccard',
  'seo.description': 'Subtítulos bilingües en YouTube. Toca una línea, convierte en tarjetas las palabras que vale la pena aprender, y FSRS hace que cada una vuelva antes de que la olvides.',
}
